import { TextSelection } from 'prosemirror-state'

import { Command } from 'common/Prose/Commands'

export const preventZeroWidthSpaceDelete: Command = (
  {
    doc,
    selection,
    selection: {
      $from: { nodeBefore },
      empty,
      from,
    },
    tr,
  },
  dispatch,
) => {
  if (!empty) return false
  if (!nodeBefore?.textContent.endsWith('\u200B')) return false

  if (from < 2) return false

  dispatch?.(tr.delete(from - 2, from - 1).setSelection(TextSelection.create(tr.doc, from - 2)))

  return true
}
